import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CaptchaValidatorDirective } from './captcha-validator.directive';
import { CdkDetailRowDirective } from './cdk-detail-row.directive';
import { DragAndDropDirective } from './drag-and-drop.directive';
import { EmailExistsValidator } from './email-exists-validator.directive';
import { EmailValidator } from './email-validator.directive';
import { EqualValidator } from './equal-validator.directive';
import { GoogleSearchDirective } from './google-search/google-search.directive';
import { Int32ValidatorDirective } from './int32-validator/int32-validator.directive';
import { MatChipPasteDirective } from './mat-chip-paste.directive';
import { NumberValidator } from './number-validator.directive';
import { OnlyNumberDirective } from './only-number.directive';
import { PhoneValidator } from './phone-validator.directive';
import { SelectFirstInputDirective } from './select-first-input.directive';
import { SmallIntValidatorDirective } from './small-int-validator.directive';
import { TemplateExistsValidatorDirective } from './template-exists-validator.directive/template-exists-validator.directive';
import { TimeAllowedValidator } from './time-allowed-validator.directive';
import { UsernameValidator } from './username-validator.directive';
import { InfiniteScrollDirective} from "./infinite-scroll.directive";
import {PostalCodeValidatorDirective} from "./postal-code-validator.directive";
import { ZipCodeValidatorDirective } from './zip-code-validator.directive';
import { Plus4ValidatorDirective } from './plus4-validator.directive';
import { NumberFormatterDirective } from './number-formatter.directive'


@NgModule({
	declarations: [
		UsernameValidator,
		NumberValidator,
		EqualValidator,
		EmailValidator,
		PhoneValidator,
		SelectFirstInputDirective,
		TimeAllowedValidator,
		OnlyNumberDirective,
		GoogleSearchDirective,
		EmailExistsValidator,
		DragAndDropDirective,
		TemplateExistsValidatorDirective,
		CdkDetailRowDirective,
		CaptchaValidatorDirective,
		MatChipPasteDirective,
		Int32ValidatorDirective,
		SmallIntValidatorDirective,
		InfiniteScrollDirective,
		PostalCodeValidatorDirective,
		ZipCodeValidatorDirective,
		Plus4ValidatorDirective,
		NumberFormatterDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		UsernameValidator,
		NumberValidator,
		EqualValidator,
		EmailValidator,
		PhoneValidator,
		SelectFirstInputDirective,
		TimeAllowedValidator,
		OnlyNumberDirective,
		GoogleSearchDirective,
		EmailExistsValidator,
		DragAndDropDirective,
		TemplateExistsValidatorDirective,
		CdkDetailRowDirective,
		CaptchaValidatorDirective,
		MatChipPasteDirective,
		Int32ValidatorDirective,
		SmallIntValidatorDirective,
		InfiniteScrollDirective,
		PostalCodeValidatorDirective,
		ZipCodeValidatorDirective,
		Plus4ValidatorDirective,
		NumberFormatterDirective
	]
})
export class DirectivesModule {
}
